import { APP_INITIALIZER, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { AppComponent } from './app.component';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { ClientDetailsInterceptor, initializeKeycloak, MobileBottomNavComponent } from '@zikata-frontend/auth';
import { KeycloakAngularModule, KeycloakService } from 'keycloak-angular';
import { environment } from '../environments/environment';
import { AppRoutesModule } from './app.routes';
import {
  HeaderComponent,
  SenderStateService,
  SidebarComponent,
  UiModule,
  UserInfoComponent,
  UserInfoConfigService,
  ZikatagPageHeaderComponent,
  ZikataToastContainerComponent,
} from '@zikata-frontend/ui';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { DatePipe } from '@angular/common';
import { NgbModule, NgbDropdown, NgbDropdownItem, NgbDropdownMenu, NgbDropdownToggle, NgbPagination, NgbNavModule } from '@ng-bootstrap/ng-bootstrap';
import { ClipboardModule } from '@angular/cdk/clipboard';
import { NgxPaginationModule } from 'ngx-pagination';
import { NgMultiSelectDropDownModule } from 'ng-multiselect-dropdown';
import { AddHeaderInterceptor } from './core/interceptors/add-header-interceptor.service';
import { ClientsPortalUserInfoConfigService } from './core/service/clients-portal-user-info-config.service';
import { provideCharts, withDefaultRegisterables } from 'ng2-charts';
import { AuthLayoutComponent } from './layouts/auth-layout/auth-layout.component';
import { DefaultLayoutComponent } from './layouts/default-layout/default-layout.component';
import { NgIconComponent } from '@ng-icons/core';

@NgModule({
  declarations: [
    AppComponent,
    AuthLayoutComponent,
    DefaultLayoutComponent,
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    AppRoutesModule,
    HttpClientModule,
    KeycloakAngularModule,
    FormsModule,
    UiModule,
    ReactiveFormsModule,
    NgbDropdownMenu,
    NgbDropdown,
    NgbDropdownToggle,
    NgbDropdownItem,
    NgbPagination,
    NgbNavModule,
    NgbModule,
    ClipboardModule,
    NgxPaginationModule,
    NgMultiSelectDropDownModule,
    SidebarComponent,
    HeaderComponent,
    ZikatagPageHeaderComponent,
    ZikataToastContainerComponent,
    NgIconComponent,
    UserInfoComponent,          // ← zikatagov-user-info
    MobileBottomNavComponent,   // ← zikatagov-mobile-bottom-nav
  ],
  providers: [
    {
      provide: APP_INITIALIZER,
      useFactory: (keycloakService: KeycloakService) => {
        return initializeKeycloak(keycloakService, {
          url: environment.authServiceUrl,
          realm: environment.authRealm,
          clientId: environment.authClientId,
          redirectUri: environment.authSuccessRedirectUrl,
        });
      },
      multi: true,
      deps: [KeycloakService],
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: ClientDetailsInterceptor,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AddHeaderInterceptor,
      multi: true,
    },
    SenderStateService,
    { provide: UserInfoConfigService, useClass: ClientsPortalUserInfoConfigService },
    DatePipe,
    provideCharts(withDefaultRegisterables()),
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}